import {
  TreatmentRecordRequestChannelType,
  TreatmentRecordRequestStatus,
  TreatmentRecordTypes,
} from '@/services/api/generated/treatmentRecordRequestsService';

export const StatusOptions: {
  label: string;
  description: string;
  value: TreatmentRecordRequestStatus;
}[] = [
  {
    label: 'Send to Provider',
    description:
      'Prepare HIPAA package and send the records request to the provider.',
    value: 'pending',
  },
  {
    label: 'Confirm Receipt',
    description: 'Records request has been submitted to the provider.',
    value: 'request_submitted',
  },
  {
    label: 'Follow-Up on Processing',
    description: 'Provider has acknowledged receiving the records request.',
    value: 'request_received',
  },
  {
    label: 'Await Invoice',
    description: 'Provider has sent an invoice. Ready to pay.',
    value: 'awaiting_invoice',
  },
  {
    label: 'Pay the Invoice',
    description: 'Invoice is ready and can be paid to the provider.',
    value: 'pending_payment',
  },
  {
    label: 'Confirm Payment Receipt',
    description:
      'Invoice is paid or not needed. Waiting for provider to deliver records.',
    value: 'records_pending',
  },
  {
    label: 'Wait for Records',
    description: 'Provider has delivered the requested records.',
    value: 'records_delivered',
  },
  {
    label: 'Completed',
    description:
      'Delivered records have been reviewed and added to the system.',
    value: 'records_ingested',
  },
  {
    label: 'Rejected',
    description: 'Records have been rejected by the provider.',
    value: 'rejected',
  },
  {
    label: 'Cancelled',
    description: 'Records have been cancelled by the provider.',
    value: 'cancelled',
  },
];

export const RecordTypeOptions: {
  label: string;
  description: string;
  value: TreatmentRecordTypes;
}[] = [
  {
    label: 'Facility Records',
    description: 'Medical records from the facility/provider.',
    value: 'Facility Records',
  },
  {
    label: 'Facility Bills',
    description: 'Facility billing / itemized statements.',
    value: 'Facility Bills',
  },
  {
    label: 'Radiology',
    description: 'Radiology reports from the provider.',
    value: 'Radiology',
  },
  {
    label: 'ER Physician Bills',
    description: 'Emergency room physician / professional bills.',
    value: 'ER Physician Bills',
  },
  {
    label: 'Other',
    description: 'Other records/bills not covered by the scopes above.',
    value: 'Other',
  },
];

export const ChannelOptions: {
  label: string;
  description: string;
  value: TreatmentRecordRequestChannelType;
}[] = [
  {
    label: 'Portal',
    description: 'Portal',
    value: 'portal',
  },
  {
    label: 'Email',
    description: 'Email',
    value: 'email',
  },
  {
    label: 'Fax',
    description: 'Fax',
    value: 'fax',
  },
  {
    label: 'Mail',
    description: 'Mail',
    value: 'mail',
  },
];

// Voice AI Follow-up Interval Options (max weekly to ensure timely follow-ups)
export const VOICE_AI_INTERVAL_OPTIONS = [
  { value: 1, label: 'Daily', description: 'Call every day' },
  { value: 2, label: 'Every 2 days', description: 'Call every other day' },
  {
    value: 3,
    label: 'Every 3 days',
    description: 'Call every 3 days (default)',
  },
  { value: 5, label: 'Every 5 days', description: 'Call twice per week' },
  { value: 7, label: 'Weekly', description: 'Call once per week (maximum)' },
] as const;

export const DEFAULT_VOICE_AI_INTERVAL = 3;

// Voice AI Follow-up Call Statuses
export const VOICE_AI_EDITABLE_STATUSES: TreatmentRecordRequestStatus[] = [
  'pending',
  'request_submitted',
  'request_received',
  'awaiting_invoice',
  'records_pending',
];

export const VOICE_AI_COMPLETED_STATUSES: TreatmentRecordRequestStatus[] = [
  'records_delivered',
  'records_ingested',
  'cancelled',
  'rejected',
  'auto_retried',
];

export const VOICE_AI_MAX_DAYS_SINCE_SUBMISSION = 14; // No calls after 14 days
